import React, { useState } from "react";
import { Plus } from "lucide-react";
import { useI18n } from "../../lib/i18n";

// Premium FAQ accordion. JSON-LD FAQPage is injected by the page-level
// useSeo() hook (see Home.jsx and ServicePage.jsx) so we don't render
// a duplicate schema here.
export const FAQ = () => {
  const { t } = useI18n();
  const f = t.faq;
  const [open, setOpen] = useState(0);

  return (
    <section
      data-testid="faq"
      className="relative py-24 md:py-32 px-6 md:px-12 lg:px-24"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        {/* Left — heading */}
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3 mb-5">
            <span className="w-12 h-px bg-brand-orange" />
            <span className="label-mono">{f.kicker}</span>
          </div>
          <h2 className="font-display font-bold text-4xl md:text-5xl lg:text-[56px] tracking-tight text-white leading-[1.05]">
            {f.title}
          </h2>
        </div>

        {/* Right — items */}
        <div className="lg:col-span-7">
          <div className="divide-y divide-white/[0.06] border-y border-white/[0.06]">
            {f.items.map((it, i) => {
              const active = open === i;
              return (
                <div key={i} data-testid={`faq-item-${i}`}>
                  <button
                    type="button"
                    onClick={() => setOpen(active ? -1 : i)}
                    className="w-full flex items-start justify-between gap-6 py-6 text-left group"
                    aria-expanded={active}
                  >
                    <span
                      className={`font-display text-lg md:text-xl tracking-tight transition-colors ${
                        active ? "text-white" : "text-white/85 group-hover:text-white"
                      }`}
                    >
                      {it.q}
                    </span>
                    <span
                      aria-hidden
                      className={`
                        w-9 h-9 shrink-0 rounded-full
                        flex items-center justify-center
                        border transition-all duration-300
                        ${active
                          ? "bg-brand-orange/20 border-brand-orange/50 rotate-45"
                          : "bg-white/[0.04] border-white/[0.10] group-hover:border-brand-orange/40"}
                      `}
                    >
                      <Plus className={`w-4 h-4 ${active ? "text-brand-orange" : "text-white/70"}`} />
                    </span>
                  </button>
                  <div
                    className={`
                      grid transition-all duration-400
                      ${active ? "grid-rows-[1fr] opacity-100 pb-6" : "grid-rows-[0fr] opacity-0"}
                    `}
                  >
                    <div className="overflow-hidden">
                      <p className="text-white/65 text-[15.5px] leading-[1.75] max-w-[58ch]">
                        {it.a}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
